// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ff772fc9","teamItem":"ff68b779","notEditable":"ac830a0b","spinnerContainer":"f388806c","icon":"d5d09eb5","matched":"e3d9975a"};